import type { AnyExtension } from "@tiptap/core";
import CodeBlockLowlight from "@tiptap/extension-code-block-lowlight";
import Image from "@tiptap/extension-image";
import { BulletList, ListItem, OrderedList, TaskItem, TaskList } from "@tiptap/extension-list";
import { Table, TableCell, TableHeader, TableRow } from "@tiptap/extension-table";
import StarterKit from "@tiptap/starter-kit";
import { CustomLink } from "./customLink.js";
import { FrontMatter, FrontMatterField } from "./frontMatterNodes.js";
import { SHARED_STARTERKIT_OPTIONS } from "./starterKitOptions.js";

/**
 * 스키마/렌더 전용 code block base. 하이라이팅 데코레이션(lowlight)은 렌더 HTML에
 * 영향이 없고, React NodeView는 프론트에서 .extend로 얹으므로 여기서는 순수 노드만 제공한다.
 */
export const BaseCodeBlock = CodeBlockLowlight;

/**
 * 프론트 에디터와 백엔드 변환기가 공유하는 스키마/렌더 확장 목록.
 * 협업/붙여넣기/키보드 등 동작 전용 확장은 포함하지 않는다.
 */
export function getContentExtensions(): AnyExtension[] {
  return [
    StarterKit.configure(SHARED_STARTERKIT_OPTIONS),
    Table.configure({ resizable: false }),
    TableRow,
    TableHeader,
    TableCell,
    BulletList,
    OrderedList,
    ListItem,
    TaskList,
    TaskItem.configure({ nested: true }),
    BaseCodeBlock,
    CustomLink.configure({ openOnClick: false, autolink: true }),
    Image,
    FrontMatter,
    FrontMatterField,
  ];
}
